import { render } from "./ApartmentFeaturesList.vue?vue&type=template&id=2f2c8a83&scoped=true"
import script from "./ApartmentFeaturesList.vue?vue&type=script&lang=js"
export * from "./ApartmentFeaturesList.vue?vue&type=script&lang=js"

import "./ApartmentFeaturesList.vue?vue&type=style&index=0&id=2f2c8a83&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2c8a83"]])

export default __exports__